import { Divider, Stack } from '@mui/material';

import { Text, api } from 'common';

import {
  BlockSelectField,
  ParentBlockSelectField,
  getSourceBlockNameHelperText,
} from '../../../ConfigFields/SelectField';
import { useSelectedNodeField } from '../../../ConfigFields/useSelectedNodeField';
import { FilterAndSortBlockFormFields } from '../FilterAndSortFormFields';

const PatientDataStore = api.FlowDefinition.PatientDataStore;

export const OrdersVariant = {
  schema: PatientDataStore.OrdersConfigSchema,
  Config: () => {
    const { setValue: setEncounters } = useSelectedNodeField('config.orderFilters.encounters');
    return (
      <Stack spacing={2}>
        <Text variant="heading5" bold>
          Order Filters
        </Text>
        <BlockSelectField
          fieldName="config.orderFilters.status"
          label="Order Status"
          options={PatientDataStore.ORDER_STATUS_OPTIONS.map((value) => ({
            label: value,
            value,
          }))}
        />
        <ParentBlockSelectField
          fieldName="config.orderFilters.encounters.sourceBlockName"
          label="Encounters Source"
          helperText={getSourceBlockNameHelperText('encounters')}
          clearable
          onClear={() => setEncounters(undefined)}
        />
        <ParentBlockSelectField
          fieldName="config.orderFilters.provider.sourceBlockName"
          label="Provider Source"
          helperText={getSourceBlockNameHelperText('provider')}
        />
        <Divider sx={{ marginY: 2 }} />
        <FilterAndSortBlockFormFields />
      </Stack>
    );
  },
};
